 
	 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig";   
    import UsuarioService from   "@/service/v1/seguranca/UsuarioService"
	import $ from "jquery"   
 
    @Options({
        name: "Curso",
        components: {  CardRh , KDataTable   },   
    }) 
    export default class Curso extends Vue {
         
        @Prop( ) readonly modelo!: any 
        @Prop( ) readonly modal!: any 
        @Prop( ) readonly service!: any
        @Prop( ) readonly perfis!: any 
 
        public reloadDatatable = false ;
        public processando = false;  
        public perfilId : any = null;  
        
        public config;  
        public identificador = 1 ;  
        public campos: Array<any> = [ ];
        public formulario: any  = { } ;   
        public usuarioService = new UsuarioService(); 
 
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
         
        created(){
            this.config = {  ajax: {} , columns: [] , columnDefs: [] };   
            
            this.config.ajax = { 
                url: this.usuarioService.getApiUrl()  ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length, 
                        "perfilId": () => (document.querySelector('[data-kt-docs-table-filter="perfilId"]')! as HTMLInputElement).value , 
                    }
                    return dados; 
                } 
            };  

            this.config.columns = [ 
                { data: 'id', name: 'id'  }, 
                { data: 'cargo', name: 'cargo' }, 
                { data: 'nome', name: 'nome' }, 
                { data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center'}   
            ];  
            this.config.columnDefs = [ 
                {
                    targets: 3 ,
                    render: ( row, type, val, meta ) => {    
                        let texto = '' ;
                        for (var key in val) {  texto = texto + ' data-' + key + '="'+ val[key] +'"'  }  
                        return  '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + texto + ' > Excluir </button>'  ; 
                    }, 
                }
            ]; 
        }
  
         
        @Watch('modelo')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
            if(this.modelo){ 
                this.perfilId = this.modelo.id; 
            }  
		}

         


        public tableatualizada( event ) { 
            $('[btn-excluir]').click(  (btn) => {   
                const perfil =   $(btn.currentTarget).data('id');   
                this.removerPerfil( perfil ); 
            });  
        }  

        
        protected removerPerfil(   user  ) {  
            let dados = {
                "perfil" : this.modelo.id.toString(),
                "id" : user.toString(),
            };
            SiteUtils.alertConfimacao('Confirma a Exclusão ','' , 
                () => {  
                    this.processando = true;  
                    setTimeout(() => {
                        this.usuarioService.removerPerfil( dados )
                        .then(response => {     
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Exclusao realizada com sucesso!!' ); 
                            this.processando = false;
                        })
                        .catch(error => { 
                            this.processando = false; 
                            SiteUtils.toastErro('Não foi possivel Excluir ' , error.data.message); 
                        });  
                    }, 10); 
                }
            );  
        }  


    } 
